import { useAppContext } from '../shared';

export const useIsMobile = () => useAppContext().isMobile;
